import { createAction } from 'redux-actions';
import { COPY2PAYLOAD, GENERATOR, SILENT } from 'uix/actions';
// record level storeKey (otid ord dname+ident)
export let setEditedWikiCode = createAction('SET_EDITED_WIKI_CODE', ({ text, storeKey, remoteUpdateTs })=>({
        text,
        storeKey,
        remoteUpdateTs
    }));
export let setWikiPreview = createAction('SET_WIKI_PREVIEW', (storeKey, preview)=>({
        storeKey,
        preview
    }));
export let saveWikiText = createAction('SAVE_WIKI_TEXT', ({ otid, dname, identifier, text, partName, mimetype })=>({
        otid,
        dname,
        identifier,
        mimetype,
        text,
        partName
    }));
